import clsx from "clsx";
import React, { useId } from "react";

import { RequiredAsterisk } from "../required-asterisk";
import { FormFieldIdProvider, formFieldLabelId } from "./form-field-id-context";
import styles from "./form-row.module.css";

export function FormRow({
  label,
  hint,
  data,
  mandatory,
  maxWidth,
}: {
  label: React.ReactNode;
  hint?: React.ReactNode;
  data: React.ReactNode;
  mandatory?: boolean;
  maxWidth?: boolean;
}) {
  const fieldId = useId();

  return (
    <>
      <div className={styles.leftColumn}>
        <div>
          <label id={formFieldLabelId(fieldId)} htmlFor={fieldId}>
            {label}: {mandatory && <RequiredAsterisk />}
          </label>
          {hint && <div className="font-normal">{hint}</div>}
        </div>
      </div>
      <FormFieldIdProvider value={fieldId}>
        <div
          className={clsx(
            styles.rightColumn,
            (maxWidth ?? true) && styles.columnMaxWidth,
          )}
        >
          {data}
        </div>
      </FormFieldIdProvider>
      <div />
    </>
  );
}
